import { useContext } from "react"
import { DataServiceContext } from "../service/DataService";

export const useDataService = () => {
    const context = useContext(DataServiceContext);
    return context;
}